import {Outlet} from "react-router";

export default function Root() {
    return <Outlet/>;
}
